import React from 'react';
import TextInput from 'components/form/TextInput';
import CheckboxGroup from 'components/form/CheckboxGroup';
import RadioGroup from 'components/form/RadioGroup';
import DatePicker from 'components/form/DatePicker';
import ColorPicker from 'components/form/ColorPicker';
import Select from 'components/form/Select';
import DropZone from 'components/form/Dropzone';

const buildOptions = (fieldOptions) => {
  if (!fieldOptions) return [];
  const options = fieldOptions.split(';');
  return options.map((option) => {
    const [label, value] = option.split('|');
    return { value, label };
  });
};

const FormField = ({ field, ...rest }) => {
  const { fieldType, fieldLabel, fieldHint, fieldOptions } = field;
  const options = field.options ?? buildOptions(fieldOptions);

  switch (fieldType) {
    case 'text':
      return (
        <TextInput fullWidth label={fieldLabel} hint={fieldHint} {...rest} />
      );
    case 'textarea':
      return (
        <TextInput
          multiline
          fullWidth
          rows={3}
          label={fieldLabel}
          hint={fieldHint}
          {...rest}
        />
      );
    case 'checkbox':
      return (
        <CheckboxGroup
          fullWidth
          options={options}
          label={fieldLabel}
          hint={fieldHint}
          {...rest}
        />
      );
    case 'radio':
      return (
        <RadioGroup
          fullWidth
          row
          options={options}
          label={fieldLabel}
          hint={fieldHint}
          {...rest}
        />
      );
    case 'date':
      return <DatePicker label={fieldLabel} hint={fieldHint} {...rest} />;
    case 'color':
      return (
        <ColorPicker
          margin="normal"
          label={fieldLabel}
          hint={fieldHint}
          {...rest}
        />
      );
    case 'select':
      return (
        <Select
          fullWidth
          transformValue
          options={options}
          label={fieldLabel}
          hint={fieldHint}
          {...rest}
        />
      );
    case 'file':
      return (
        <DropZone
          accept="*"
          margin="normal"
          label={fieldLabel}
          hint={fieldHint}
          {...rest}
        />
      );
    default:
      return (
        <TextInput
          fullWidth
          type={fieldType}
          label={fieldLabel}
          hint={fieldHint}
          {...rest}
        />
      );
  }
};

export default React.forwardRef((props, ref) => (
  <FormField ref={ref} {...props} />
));
